import { render, staticRenderFns } from "./DateValue.vue?vue&type=template&id=357e99f2&scoped=true&"
import script from "./DateValue.vue?vue&type=script&lang=js&"
export * from "./DateValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e99f2",
  null
  
)

export default component.exports